import ReceivableGif from './receivable-gif.gif';
import ShareholderGif from './shareholder-gif.gif';

export {
  ReceivableGif,
  ShareholderGif,
};
